import { React, useState } from "react";
import { FaTable, FaCalendar } from "react-icons/fa";
import { Card, Button } from "react-bootstrap";
import "../../../utils/Css/Marketing.css";
import "../../../utils/Css/Campagne.css";
import { useNavigate } from "react-router-dom";

//importer page
import TablePublication from "./TablePublication";
import CalendrierPublication from "./CalendrierPublication";

function PagePublication() {
  const [tableauClicked, setTableauClicked] = useState(true);
  const [calendarClicked, setCalendarClicked] = useState(false);
  const navigate = useNavigate();

  const handleClickTableau = () => {
    setTableauClicked(true);
    setCalendarClicked(false);
  };

  const handleClickCalendar = () => {
    setTableauClicked(false);
    setCalendarClicked(true);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card  mt-3">
                <div className="card-body">
                  <h5 className="card-title">Les publications</h5>
                  <button
                    class="btn btn-dark float-right"
                    onClick={() => navigate("/AddPublication")}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}

      {/* content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row d-flex justify-content-center">
                    {/* Button vers la page Tableau */}
                    <div className="col">
                      <Button
                        className="my-custom-class-btn-style mr-2"
                        variant="secondary"
                        disabled={tableauClicked}
                        onClick={handleClickTableau}
                      >
                        <FaTable className="icon-campagne mr-3" />
                        Tableau
                      </Button>
                    </div>
                    {/* /.Button vers la page Tableau */}
                    {/* Button vers la page calendrier */}
                    <div className="col">
                      <Button
                        className="my-custom-class-btn-style mr-2"
                        variant="secondary"
                        disabled={calendarClicked}
                        onClick={handleClickCalendar}
                      >
                        <FaCalendar className="icon-campagne mr-3" />
                        Calendrier
                      </Button>
                      {/* /.Button vers la page calendrier */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*/.Buttons Calendrier et tableau */}
          {/* card */}

          {tableauClicked && <TablePublication />}
          {calendarClicked && <CalendrierPublication />}
          {/*/.card */}
        </div>
        {/* /.container-fluid */}
      </section>
      {/* /.content */}
    </div>
  );
}

export default PagePublication;
